import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseRequestResultModel } from '../models/base-request-result.model';
import { BaseService } from './base.service';

@Injectable({
	providedIn: 'root',
})
export class CmsService extends BaseService {
	constructor(private readonly http: HttpClient) {
		super();
	}

	resolve(slug: any): any {
		return this.getPageBySlug(slug);
	}

	getPageBySlug(slug: string) {
		return this.http
			.post<BaseRequestResultModel>(`${environment.apiUrl}cms`, {
				path: 'pages?slug=' + slug,
			})
			.pipe(map(this.extractData));
	}

	getByPath(path: string) {
		return this.http.post<any>(`${environment.apiUrl}cms`, {
			path: path,
		});
	}
}
